module.exports = __webpack_public_path__ + "img/thumb_31.2c3bb60a.jpg";